import React, { createContext, useContext } from 'react';
import Swal from 'sweetalert2';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    },
  });

  const showToast = (options, variant = 'default') => {
    const variantOptions = getVariantOptions(variant);
    const mergedOptions = { ...variantOptions, ...options };
    Toast.fire(mergedOptions);
  };

  const getVariantOptions = (variant) => {
    switch (variant) {
        case 'success-swal':
            return {
                icon: 'success',
                toast: false,
                position: 'center',
                showConfirmButton: true,
                timer: undefined,
                timerProgressBar: false,
            };
        case 'success-toast':
            return {
                icon: 'success',
                toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
            };
        case 'error-swal':
            return {
                icon: 'error',
                toast: false,
                position: 'center',
                showConfirmButton: true,
                timer: undefined,
                timerProgressBar: false,
            };
        case 'error-toast':
            return {
                icon: 'error',
                toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
            };
        case 'info-swal':
            return {
                icon: 'info',
                toast: false,
                position: 'center',
                showConfirmButton: true,
                timer: undefined,
                timerProgressBar: false,
            };
        case 'info-toast':
            return {
                icon: 'info',
                toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
            };
        case 'warning-swal':
            return {
                icon: 'info',
                toast: false,
                position: 'center',
                showConfirmButton: true,
                timer: undefined,
                timerProgressBar: false,
            };
        case 'warning-toast':
            return {
                icon: 'warning',
                toast: true,
                position: 'top',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
            };
      // Diğer varyasyonlar için gerekli case'leri ekleyebilirsiniz.
      default:
        return {};
    }
  };

  const contextValue = {
    showToast,
  };

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};